import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '@narvar/nth-button';
import { receivePendingCancelReturnId } from '../../actions/page';

const mapStateToProps = ({ language, page: { pendingCancelReturnId } }) => ({
  language,
  pendingCancelReturnId,
});

const CancelReturnModal = ({
  dispatch,
  language,
  pendingCancelReturnId,
  label,
  onConfirmCancel,
}) => {
  const { return_id: id, return_method: returnMethod } = label;
  const {
    [`returns.step_1.cancel_return_modal.${returnMethod}.title`]: title,
    [`returns.step_1.cancel_return_modal.${returnMethod}.description`]: description,
    [`returns.step_1.cancel_return_modal.${returnMethod}.confirm_button`]: confirmText,
    [`returns.step_1.cancel_return_modal.${returnMethod}.back_button`]: backText,
  } = language;
  const closeModal = () => dispatch(receivePendingCancelReturnId(null));

  return (
    <div>
      <Modal
        isOpen={id === pendingCancelReturnId}
        onRequestClose={closeModal}
        style={{
          overlay: {
            zIndex: '999',
            backgroundColor: 'rgb(0, 0, 0, 0.7)',
            animation: 'fadeIn 0.5s',
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '700px',
            minHeight: '250px',
            padding: '2rem 3rem',
            borderRadius: '0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          },
        }}
      >
        <div className="cancel-return-modal-content">
          <h2
            style={{
              margin: '0 7rem 1rem 0',
              lineHeight: '2rem',
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {title}
          </h2>
          <p style={{ margin: '1rem 0' }}>{description}</p>
        </div>
        <div
          style={{
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            s={{
              fontSize: '0.8rem',
              width: '120px',
            }}
            className="narvar-btn-tertiary"
            onClick={closeModal}
          >
            {backText}
          </Button>
          <Button
            s={{
              fontSize: '0.8rem',
              width: '250px',
              height: '48px',
            }}
            className="narvar-btn-primary"
            onClick={(event) => {
              closeModal();
              onConfirmCancel(label, event);
            }}
          >
            {confirmText}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

CancelReturnModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  pendingCancelReturnId: PropTypes.number.isRequired,
  label: PropTypes.shape({
    return_id: PropTypes.number.isRequired,
    return_method: PropTypes.string.isRequired,
  }).isRequired,
  onConfirmCancel: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CancelReturnModal);
